import axios from "axios";
import { delay, put, takeLatest, takeEvery, CallEffect } from "redux-saga/effects";
import { linkRestrictionReceived, receivedSourceIds } from "../actions/LinkRestriction";
import {
    GET_LINK_RESTRICTION,
    GET_SOURCE_IDS,
    GetLinkRestriction,
    GetSourceIds,
    GetLinkRestrictionDefaultData,
    ReceivedSourceIds,
    LinkRestrictionReceived
} from "../actions/LinkRestriction/types";
import { getRequest, showError } from "../components/commonUtilities";
import { decrypt } from "../Utilities/decryption";
import { isPathPublicViewer } from "../Utilities/generalUtilities";
import { clone } from "lodash";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";

function* getLinkRestriction(
    action: GetLinkRestriction
): Generator<
    | GeneratorYieldType<LinkRestrictionReceived["payload"]>
    | Promise<LinkRestrictionReceived>
    | CallEffect<true>,
    void,
    any
> {
    // If the links data are from geoserver, then access regulation_id from properties
    const { id, defaultData } = action.payload;
    if (
        defaultData.regulation_id ||
        (defaultData as GetLinkRestrictionDefaultData).properties?.regulation_id
    ) {
        const getPath = isPathPublicViewer();
        try {
            let json = getPath
                ? yield getRequest(
                      `/api/links/${id}/get_public_link_restrictions/`,
                      action.payload.params
                  )
                : yield getRequest(
                      `/api/links/${id}/get_link_restrictions/`,
                      action.payload.params
                  );

            json = decrypt(json);

            const result = clone(defaultData);

            result.timeData = json;
            result.id = id;
            yield put(linkRestrictionReceived({ data: result as GetLinkRestrictionDefaultData }));
        } catch (e) {
            showError(e);
        }
    } else {
        yield delay(1000);
        const result = { ...defaultData };
        result.timeData = action.payload.defaultData
            .timeData as GetLinkRestriction["payload"]["defaultData"]["timeData"];

        result.id = id;
        yield put(linkRestrictionReceived({ data: result as GetLinkRestrictionDefaultData }));
    }
}

export function* getLinkRestrictionSaga() {
    yield takeEvery(GET_LINK_RESTRICTION, getLinkRestriction);
}

function* getSourceIds(
    action: GetSourceIds
): Generator<
    Promise<ReceivedSourceIds> | GeneratorYieldType<ReceivedSourceIds["payload"]>,
    void,
    ReceivedSourceIds["payload"]["sourceIds"]
> {
    try {
        let json = yield axios
            .get(
                `/api/link-sensor-map/?fields=sensor_type_1__source_id&link=${action.payload.linkId}`
            )
            .then((response) => response.data);
        yield put(receivedSourceIds({ sourceIds: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getSourceIdsSaga() {
    yield takeLatest(GET_SOURCE_IDS, getSourceIds);
}
